import {
  alpha,
  Grid,
  TextField,
  useTheme
} from '@mui/material';
import { AgencyQuestion } from '../../../utils/types';
import Utils from '../../../utils/utils';
import { useUser } from '../../../hooks/useUser';
import { createAgencyQuestion } from '../../../networkRequest/agenciesService';
import DialogForm from '@components/Dialog/DialogForm';

interface AgencyQuestionDialogFormProps {
  open: boolean;
  close: () => void;
  agencyId: string | number;
  onError: (string) => void;
  onSuccess: (agencyQuestion: AgencyQuestion) => void;
}
const AgencyQuestionDialogForm = ({
  open,
  close,
  agencyId,
  onError,
  onSuccess
}: AgencyQuestionDialogFormProps) => {
  const theme = useTheme()
  const { user } = useUser();

  const textFieldSx = {
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: theme.palette.primary.dark,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: alpha(theme.palette.text.primary, 0.23)
      }
    }
  };

  const submitForm = async (form: HTMLFormElement) => {
    const formData = new FormData(form);

    const payload: Partial<AgencyQuestion> = {
      question: formData.get('question')?.toString().trim(),
      description: Utils.nullIfEmpty(formData.get('description')?.toString().trim())
    };

    const response = await createAgencyQuestion(user!.accessToken, agencyId, payload)

    if(response.data) {
      onSuccess(response.data)
    } else {
      throw new Error(response.error)
    }
  }

  return (
    <DialogForm
      submitForm={submitForm}
      open={open}
      onClose={close}
      onError={onError}
      title="Additional Verification Question"
      testId="agency-question-dialog"
    >
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <TextField
          label="Question"
          multiline
          sx={textFieldSx}
          name="question"
          placeholder="Do you have an appointment today?"
          slotProps={{
            inputLabel: {
              shrink: true
            }
          }}
          fullWidth
          required
        />
        <TextField
          label="Description"
          sx={textFieldSx}
          name="description"
          placeholder="Verifies that the visitor has a legitimate, pre-arranged reason to be at the location."
          slotProps={{
            inputLabel: {
              shrink: true
            }
          }}
          fullWidth
        />
      </Grid>
    </DialogForm>
  );
};

export default AgencyQuestionDialogForm;
